import { Button, Col, Container, Row } from "react-bootstrap";
import "../css/App.css";
import Header from "./header";
import Footer from "./footer";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import { AuthContext } from "../../../services/auth";

const CustomButton = ({ children, ...props }) => {
  const { isEnglish } = useContext(AuthContext);
  return (
    <Container fluid className="m-0 w-100 margin-custom-cookies">
      <Container className=" container-custom-cookies">
        <Row className="d-flex align-items-center justify-content-center">
          <Col className="text-center d-flex align-items-center justify-content-center margin-custom-text-cookies">
            <h6 className="m-0 font-custom text-center text-white ">
              {isEnglish
                ? "We use cookies to ensure that we give you the best experience on our website. "
                : "Usiamo i cookie per assicurarci di offrirti la migliore esperienza sul nostro sito web."}
            </h6>
          </Col>
          <Col className="text-center container-button-accept d-flex align-items-center justify-content-center">
            <Button {...props}>{isEnglish ? "Allow" : "Accetto"}</Button>
          </Col>
          <Col className="text-center link-cookies"><Link to="cookie-policy" className=" text-white" >Cookie Policy</Link></Col>
        </Row>
      </Container>
    </Container>
  );
};

const App = () => {
  const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  };
  return (
    <Container fluid className="color_app  m-0 p-0">
      <Header />
      <ScrollToTop />
      <Container fluid className="container_app h-100 mx-0 p-0 ">
        <Outlet />
      </Container>
      <CookieConsent
        buttonClasses="button-accept"
        buttonWrapperClasses="col-12"
        ButtonComponent={CustomButton}
        containerClasses="w-100 d-flex align-items-center justify-content-center  col-12 bg-transparent"
      ></CookieConsent>
      <Footer />
    </Container>
  );
};

export default App;
